
import { createPortal } from 'react-dom';
import close from '../../assets/icons/close.svg';
import React from "react";

const FeePlanShowModal = ({
  isOpen,
  onClose,
  studentName,
  feePlan,
  selectedFeeHeads,
  setSelectedFeeHeads
}) => {
  if (!isOpen) return null;

  const handleCheckboxChange = (feeHead) => {
    if (selectedFeeHeads.includes(feeHead)) {
      // remove from selection
      setSelectedFeeHeads(selectedFeeHeads.filter((head) => head !== feeHead));
    } else {
      // add to selection
      setSelectedFeeHeads([...selectedFeeHeads, feeHead]);
    }
  };

  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        style={{ width: "30%", background: "#fff", padding: "20px" }}
      >
        <div
          className="modal-header-content"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px'
          }}
        >
              <h4 style={{ marginBottom: "10px", fontSize: '16px' }}>{studentName}'s Fee Plan</h4>
          <button
            className="close-btn"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }}
          >
            <img src={close} alt="close" />
          </button>
        </div>
     
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}></th>
              <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>Semester</th>
              <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>Fee Head</th>
              <th
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                  textAlign: "right"
                }}
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {feePlan && feePlan.feePlan?.length > 0 ? (
              feePlan.feePlan.map(({ semester, fee_head, amount }, index) => {
                const isChecked = selectedFeeHeads.includes(fee_head);

                return (
                  <tr key={index}>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleCheckboxChange(fee_head)}
                        disabled 
                      />
                    </td>
                    <td className='sd-p' style={{ padding: "8px" }}>{semester}</td>
                    <td className='sd-p' style={{ padding: "8px" }}>{fee_head}</td>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "right",
                        color: "#6B778C"
                      }}
                    >
                      ₹ {amount}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={4}
                  style={{ padding: "8px", textAlign: "center", color: "#777" }}
                >
                  No fee plan available
                </td>
              </tr>
            )}
          </tbody>
        </table>


      </div>
    </div>
  );
};

export default FeePlanShowModal;
